import React, { useState, useMemo, useEffect } from "react";

import { Modal } from "../../../../../BP2Components";
import { useDispatch, useSelector } from "react-redux";
import { checkIfAsystentShouldBeUnlocked, getChatModalSize } from "../../ChatScripts";
import { changeAssistantStatus } from "../../firebaseCRUD";
import { useChat } from "../../../../../../context/ChatContext/ChatContext";
import { setIsChatOpen } from "../../../../../../appRedux/actions/ChatSettings";

//@ts-ignore
import IntlMessages from "@util/IntlMessages";

//@ts-ignore
import projectConfig from "@projectConfig";

import "./../../ChatStyle.less";
import ChatTopBar from "./ChatTopBar";
import ChatTabs from "./ChatTabs";
import ChatRoomsList from "./ChatRoomsContainer/ChatRoomsListController";
import ChatMessagesContainer from "./ChatMessagesContainer/ChatMessagesContainer";
import ChatMessagesTopBar from "./ChatMessagesContainer/ChatMessagesTopBar";
import ChatInput from "../ChatInput";
import ChatCreateNewRoom from "../../ChatSettings/ChatCreateNewRoom";

const ChatWindow = ({ sortedRooms, messages }) => {
   const chatSettings = useSelector((state) => state.chatSettings);
   const { chatData } = useChat();

   const dispatch = useDispatch();

   const [isCreateRoomModalOpen, setIsCreateRoomModalOpen] = useState(false);

   const query = new URLSearchParams(window.location.search);
   const actionIdFromUrl = query.get("actionId");

   const instanceId = useMemo(
      () => sortedRooms?.find((room) => room?.id === chatSettings?.currentRoom?.id)?.instanceId,
      [sortedRooms?.length, chatSettings?.currentRoom?.id],
   );

   const currentRoom = chatData?.allRooms?.find(
      (room) => room?.id === chatSettings?.currentRoom?.id,
   );

   const hasChatRooms = sortedRooms && sortedRooms.length > 0;
   const hasNoRooms = !hasChatRooms;

   const handleOpenCreateModal = () => {
      setIsCreateRoomModalOpen(true);
   };

   const handleCloseCreateModal = () => {
      setIsCreateRoomModalOpen(false);
   };

   const handleRoomCreated = () => {
      setIsCreateRoomModalOpen(false);
   };

   // checking if newest message is older then 2min. If so, changing bot busy status to false
   useEffect(() => {
      if (checkIfAsystentShouldBeUnlocked(messages)) {
         changeAssistantStatus("rooms/", currentRoom?.key, "false");
      }
   }, [messages, chatSettings]);

   return projectConfig.hideChat === true ? null : (
      <>
         <Modal
            isOpen={chatSettings?.isChatOpen && !isCreateRoomModalOpen}
            width={getChatModalSize("width", chatSettings?.fullScreenMode)}
            height={getChatModalSize("height", chatSettings?.fullScreenMode)}
            onCancel={() => dispatch(setIsChatOpen(false))}
            bodyStyles={{
               margin: "0px",
               padding: "0px",
               overflow: "hidden",
               display: "flex",
               flexDirection: "column",
            }}
            topBarContent={<ChatTopBar />}
         >
            <div className="main-chat-container">
               <ChatTabs />
               <ChatRoomsList onOpenCreateModal={handleOpenCreateModal} />
               {chatSettings?.currentRoom?.id ? (
                  <div className="main-chat-container__room-container">
                     <ChatMessagesTopBar
                        actionIdFromUrl={actionIdFromUrl}
                        instanceId={instanceId}
                        chatRoomType={chatSettings.currentRoom.type}
                     />
                     <ChatMessagesContainer />
                     <ChatInput />
                  </div>
               ) : (
                  <div className="main-chat-container__room-container">
                     <div
                        style={{
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                           width: "100%",
                           height: "100%",
                        }}
                     >
                        <IntlMessages id="chat.open-room" />
                     </div>
                  </div>
               )}
            </div>
         </Modal>

         {chatSettings?.isChatOpen && isCreateRoomModalOpen && (
            <Modal
               topBarContent={<IntlMessages id="chat.createNewRoom" />}
               isOpen={isCreateRoomModalOpen}
               onCancel={handleCloseCreateModal}
               width={500}
               height={550}
            >
               <ChatCreateNewRoom
                  onCancel={handleCloseCreateModal}
                  onRoomCreated={handleRoomCreated}
               />
            </Modal>
         )}
      </>
   );
};
export default ChatWindow;
